import React from 'react';
import {View, Text} from '@react-pdf/renderer';
import styles from '../styles';
import {ControlItem, ControlName} from './ControlsComponents';

const SecondSection = props => {
  return (
    <View style={styles.row}>
      <View style={[styles.width5, styles.sectionHeader, styles.center]}>
        <Text style={[styles.text10, styles.rotated, {width: '250%'}]}>
          Çdo dy muaj
        </Text>
      </View>
      <View style={[styles.flex1, styles.borderLeft]}>
        <View style={[styles.row]}>
          <ControlName text="Rollerët (zinxhiri) i shkelësve" />
          <View style={styles.flex1}>
            <View style={styles.row}>
              <ControlItem
                text="Kontrollo tensionerin e zinxhirit të shkelësve"
                selected={props.check11}
              />
              <ControlItem
                text="Vajosja rollerëve (zinxhiri) i shkelësve"
                selected={props.check12}
                style={[styles.flex1, styles.center]}
              />
            </View>
            <View style={styles.row}>
              <ControlItem
                text="Nëse kërkohet rregullimi (kalibrimi) a është bërë?"
                style={[styles.flex1]}
                selected={props.check13}
              />
            </View>
          </View>
        </View>
        <View style={styles.row}>
          <ControlName
            text={`Zinxhiri i ngasjes së handrail \n(parmakut të gomës)`}
          />
          <View style={styles.flex1}>
            <View style={styles.row}>
              <ControlItem
                text="Lëvizja (lirimi) i zinxhirit të ngasjes së handrail është ndërmjet 10-15mm në lëvizje të lirë"
                style={[styles.flex1]}
                selected={props.check14}
              />
            </View>
            <View style={styles.row}>
              <ControlItem
                text="Vajosja zinxhirin i ngasjes së handrail (parmakut të gomëes)"
                style={[styles.flex1]}
                selected={props.check15}
              />
            </View>
            <View style={styles.row}>
              <ControlItem
                text="Nëse kërkohet rregullimi (kalibrimi) a është bërë?"
                style={[styles.flex1]}
                selected={props.check16}
              />
            </View>
          </View>
        </View>
        <View style={styles.row}>
          <ControlName text="Zinxhiri ngasës" />
          <View style={styles.flex1}>
            <View style={styles.row}>
              <ControlItem
                selected={props.check17}
                style={[styles.flex1]}
                text="Lëvizja (lirimi) e zinxhirit ngasës është ndërmjet 10-15mm gjatë lëvizjes"
              />
            </View>
            <View style={styles.row}>
              <ControlItem
                text="Vajosja e zinxhirit ngasës"
                selected={props.check18}
              />
              <ControlItem
                text="Nëse kërkohet rregullimi (kalibrimi) a është bërë?"
                style={[styles.flex1, styles.center]}
                selected={props.check19}
              />
            </View>
          </View>
        </View>
        <View style={styles.row}>
          <ControlName text="Njësia ngasëse (motori)" />
          <View style={styles.flex1}>
            <View style={styles.row}>
              <ControlItem
                selected={props.check20}
                style={[styles.flex1]}
                text="Kontrollo nivelin e vajit të motorit"
              />
            </View>
            <View style={styles.row}>
              <ControlItem
                text="Nuk ka rrjedhje në motor "
                selected={props.check21}
              />
              <ControlItem
                text="Nuk ka zhurmë të jashtëzakonshme në motor"
                style={[styles.flex1, styles.center]}
                selected={props.check22}
              />
            </View>
            <View style={styles.row}>
              <ControlItem
                text="Nëse kërkohet rregullimi (kalibrimi) a është bërë?"
                style={[styles.flex1]}
                selected={props.check23}
              />
            </View>
          </View>
        </View>
      </View>
    </View>
  );
};

export default SecondSection;
